import styled from 'styled-components';

export const Button = styled.div`
  height: 32px;
  width: ${(props) => props.width || '100%'};
  background-color: ${(props) =>
    props.type === 'primary' ? '#FFF28D' : '#DEDEDE'};
  box-shadow: 0px 3px 6px #00000029;
  border-radius: 3px;
  cursor: pointer;

  margin: ${(props) => props.margin ||  '' };

  display: flex;
  justify-content: center;
  align-items: center;

  font-size: 11px;
  font-weight: 700;
  color: #145b99;
`;

export const Icon = styled.img`
  margin-right: 10px;
  width: 15px;
  height: 15px;
`;
